module.exports = __webpack_public_path__ + "img/partner_logo11.e65591c1.png";